import React, { useRef } from "react";
import {
  AudioContextRef,
  CanvasContextRef,
  ChatWindowContextRef,
  LastFrameContext,
  VideoContextRef,
  ZoomContextRef,
} from "../../pages/CurrentModel";

export default function ChatContextContainer({ children }) {
  const videoRef = useRef();
  const audioRef = useRef();
  const canvasRef = useRef();
  const chatWindowRef = useRef();
  const divZoomRef = useRef();
  const lastFrameRef = useRef();

  return (
    <VideoContextRef.Provider value={videoRef}>
      <AudioContextRef.Provider value={audioRef}>
        <CanvasContextRef.Provider value={canvasRef}>
          <ChatWindowContextRef.Provider value={chatWindowRef}>
            <LastFrameContext.Provider value={lastFrameRef}>
              <ZoomContextRef.Provider value={divZoomRef}>{children}</ZoomContextRef.Provider>
            </LastFrameContext.Provider>
          </ChatWindowContextRef.Provider>
        </CanvasContextRef.Provider>
      </AudioContextRef.Provider>
    </VideoContextRef.Provider>
  );
}
